import { Menu } from '@material-ui/core';
import React, { useState } from 'react';
import { Button, DropdownItem } from "reactstrap"
import { HasPermission } from "../helpers/HasPermission"


export const ActionButtons = ({actions, type, row, actionsDisabled=false, grouped=false, customHeader=false, printName=false, print=false, showLabels=false}) => {

    const [menuVisible, setMenuVisible] = useState(false)
    const [menuPosition, setMenuPosition] = useState({top:0, left:0})

    const buttonClass = (action) => {
        const base = 'btn-sm waves-effect waves-light'
        const custom = action.customButtonStyle ? 'border-0' : ''
        const layout = showLabels ? 'd-inline-flex align-items-center' : ''
        const gap = showLabels ? 'mr-1 mb-1' : ''
        return [base, custom, layout, gap].filter(Boolean).join(' ')
    }

    const buttonStyle = (action) => {
        if (action.customButtonStyle) {
            return showLabels
                ? { ...action.customButtonStyle, gap: '6px' }
                : action.customButtonStyle
        }
        if (showLabels) {
            return { display: 'inline-flex', alignItems: 'center', gap: '6px' }
        }
        return undefined
    }

    const ButtonType = () => (
        actions.map((action,key)=>(
            (!action.permission) || (HasPermission(action.permission)) ? (
                <React.Fragment  key={key}>
                    <Button
                        disabled={actionsDisabled}
                        title={action.label}
                        color={action.customButtonStyle ? 'secondary' : action.color}
                        className={buttonClass(action)}
                        style={buttonStyle(action)}
                        onClick={()=>action.fn({ row: row, printName: printName, print: print, customHeader: (customHeader ? customHeader.replace("{rowlabel}",action.label) : false), ...action.params })}
                    >
                        {showLabels ? (
                            <>
                                <i className={`${action.icon} d-block font-size-12`} style={{ flexShrink: 0 }} aria-hidden />
                                <span style={{ fontSize: '0.72rem', lineHeight: 1.15, fontWeight: 600, whiteSpace: 'nowrap' }}>
                                    {action.shortLabel || action.label}
                                </span>
                            </>
                        ) : (
                            <i className={action.icon+" d-block font-size-12"} />
                        )}
                    </Button>
                    {grouped ? null : (
                        <>&nbsp;</>
                    )}
                </React.Fragment>
            ) : null
        ))
    )

    const MenuType = () => (
        <React.Fragment>
            <Button color='secondary' disabled={actionsDisabled} className='btn-sm waves-effect waves-light' onClick={(e)=>{ const el = e.target.getBoundingClientRect();setMenuPosition({top: el.top+30, left:el.left});setMenuVisible(!menuVisible)} }>
                Actions{" "}<i className="mdi mdi-chevron-down"></i>
            </Button>
            <Menu disableAutoFocusItem anchorReference="anchorPosition" anchorPosition={menuPosition} keepMounted open={Boolean(menuVisible)} onClose={()=>setMenuVisible(false)}>
                {actions.map((action,key)=>(
                    (!action.permission) || (HasPermission(action.permission)) ? (
                        <DropdownItem toggle={false} onClick={()=>{
                            setMenuVisible(false);
                            action.fn({ row: row, printName: printName, print: print, customHeader: (customHeader ? customHeader.replace("{rowlabel}",action.label) : false), ...action.params })
                        }} key={key}><span className={action.icon+" d-block font-size-14"}>{" "}{action.shortLabel || action.label}</span></DropdownItem>
                    ) : null
                ))}
            </Menu>
        </React.Fragment>
    )

    return (
        <React.Fragment>
            {type === "buttons" ? <ButtonType /> : <MenuType />}
        </React.Fragment>
    )

}
